import { render, staticRenderFns } from "./apartments-locations-overview-projects.vue?vue&type=template&id=0a9f7f88&"
import script from "./apartments-locations-overview-projects.ts?vue&type=script&lang=ts&"
export * from "./apartments-locations-overview-projects.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-locations-overview-projects.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports